module.exports = __webpack_public_path__ + "media/metal_sheet_3.4e1a2cba.webm";